export default __webpack_public_path__ + "static/media/ModalBG@2x.b6a0545e.png";